"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _elements = require("./elements");

var _default = {
  account: _elements.NavAccount,
  "add-person-user": _elements.NavAddPersonUser,
  "add-plus": _elements.NavAddPlus,
  "all-done": _elements.NavAllDone,
  android: _elements.OsAndroid,
  announcement: _elements.CommunicationsAnnouncement,
  api: _elements.TechnologyApi,
  "applications-apps": _elements.NavApplicationsApps,
  "arrow-circle-down": _elements.NavArrowCircleDown,
  "arrow-circle-left": _elements.NavArrowCircleLeft,
  "arrow-circle-right": _elements.NavArrowCircleRight,
  "arrow-circle-up": _elements.NavArrowCircleUp,
  "arrow-down": _elements.NavArrowDown,
  "arrow-left": _elements.NavArrowLeft,
  "arrow-right": _elements.NavArrowRight,
  "arrow-up": _elements.NavArrowUp,
  attachment: _elements.FileAttachment,
  "backspace-delete": _elements.NavBackspaceDelete,
  baidu: _elements.SocialBaidu,
  "baidu-box": _elements.SocialBaiduBox,
  "block-diagram": _elements.MediaBlockDiagram,
  blockchain: _elements.TechnologyBlockchain,
  "blog-post": _elements.MediaBlogPost,
  bluetooth: _elements.TechnologyBluetooth,
  book: _elements.MediaBook,
  bookmark: _elements.NavBookmark,
  "bug-report": _elements.TechnologyBugReport,
  business: _elements.CommunicationsBusiness,
  calendar: _elements.TimeCalendar,
  call: _elements.CommunicationsCall,
  camera: _elements.ApplicationsCamera,
  cancel: _elements.NavCancel,
  car: _elements.ApplicationsAutomotiveCar,
  "caret-down": _elements.NavCaretDown,
  "caret-left": _elements.NavCaretLeft,
  "caret-right": _elements.NavCaretRight,
  "caret-up": _elements.NavCaretUp,
  "chart-data-outline": _elements.GeneralChartDataOutline,
  chat: _elements.CommunicationsChat,
  "chat-bubble-news": _elements.CommunicationsChatBubbleNews,
  check: _elements.NavCheck,
  "check-circle": _elements.NavCheckCircle,
  "checkbox-empty": _elements.NavCheckboxEmpty,
  "checkbox-selected": _elements.NavCheckboxSelected,
  chip: _elements.ProductsChip,
  "chip-code": _elements.TechnologyChipCode,
  chipset: _elements.ProductsChipset,
  "city-smart": _elements.ApplicationsCitySmart,
  close: _elements.NavClose,
  cloud: _elements.FileCloud,
  "cloud-done": _elements.FileCloudDone,
  "cloud-off": _elements.FileCloudOff,
  "cloud-upload": _elements.FileCloudUpload,
  code: _elements.TechnologyCode,
  comment: _elements.CommunicationsComment,
  "community-post": _elements.MediaCommunityPost,
  "compare-arrows": _elements.NavCompareArrows,
  connectivity: _elements.TechnologyConnectivity,
  "consumer-electronics": _elements.ApplicationsConsumerElectronics,
  "control-top": _elements.NavControlTop,
  copyright: _elements.AlertCopyright,
  "create-new-folder": _elements.FileCreateNewFolder,
  "credit-card-payment": _elements.ShoppingCreditCardPayment,
  dashboard: _elements.NavDashboard,
  "delete": _elements.NavDelete,
  "desktop-computer": _elements.DevicesDesktopComputer,
  devboard: _elements.ProductsDevboard,
  "device-hub": _elements.DevicesDeviceHub,
  devkit: _elements.ProductsDevkit,
  doc: _elements.DocumentsDoc,
  "document-imaging-scanner": _elements.ApplicationsDocumentImagingScanner,
  download: _elements.NavDownload,
  email: _elements.CommunicationsEmail,
  "email-alternate": _elements.CommunicationsEmailAlternate,
  "email-subscribe": _elements.CommunicationsEmailSubscribe,
  "email-unsubscribe": _elements.CommunicationsEmailUnsubscribe,
  "enlarge-expand": _elements.NavEnlargeExpand,
  error: _elements.AlertError,
  event: _elements.TimeEvent,
  "exit-fullscreen": _elements.AVExitFullscreen,
  extension: _elements.TechnologyExtension,
  facebook: _elements.SocialFacebook,
  "facebook-box": _elements.SocialFacebookBox,
  "fast-forward": _elements.AVFastForward,
  favorite: _elements.ShoppingFavorite,
  "favorite-border": _elements.ShoppingFavoriteBorder,
  filter: _elements.NavFilter,
  fingerprint: _elements.SecurityFingerprint,
  flickr: _elements.SocialFlickr,
  "flickr-box": _elements.SocialFlickrBox,
  folder: _elements.FileFolder,
  fullscreen: _elements.AVFullscreen,
  gaming: _elements.ApplicationsGaming,
  "generic-document": _elements.DocumentsGenericDocument,
  "globe-world-north-america": _elements.PlacesGlobeWorldNorthAmerica,
  googleplus: _elements.SocialGoogleplus,
  "googleplus-box": _elements.SocialGoogleplusBox,
  group: _elements.GeneralGroup,
  hardware: _elements.ProductsHardware,
  hd: _elements.AVHd,
  healthcare: _elements.ApplicationsHealthcare,
  help: _elements.NavHelp,
  home: _elements.NavHome,
  info: _elements.NavInfo,
  infotainment: _elements.ApplicationsAutomotiveInfotainment,
  instagram: _elements.SocialInstagram,
  "instagram-box": _elements.SocialInstagramBox,
  integration: _elements.GeneralIntegration,
  iot: _elements.ApplicationsIot,
  laptop: _elements.DevicesLaptop,
  launch: _elements.NavLaunch,
  link: _elements.NavLink,
  "link-out": _elements.NavLinkOut,
  "link-out-simple": _elements.NavLinkOutSimple,
  linkedin: _elements.SocialLinkedin,
  "linkedin-box": _elements.SocialLinkedinBox,
  linux: _elements.OsLinux,
  list: _elements.NavList,
  "live-help": _elements.CommunicationsLiveHelp,
  "location-pin": _elements.PlacesLocationPin,
  lock: _elements.SecurityLock,
  "lock-copy": _elements.SecurityLockCopy,
  loop: _elements.AVLoop,
  mac: _elements.OsMac,
  "media-chat": _elements.MediaMediaChat,
  memory: _elements.ProductsMemory,
  menu: _elements.NavMenu,
  "minus-circle-outline": _elements.NavMinusCircleOutline,
  mobilefilters: _elements.NavMobilefilters,
  modem: _elements.ProductsModem,
  more: _elements.NavMore,
  "more-circle": _elements.NavMoreCircle,
  "more-sites": _elements.NavMoreSites,
  nda: _elements.AlertNda,
  networking: _elements.ApplicationsNetworkingNetworking,
  "networking-modem": _elements.ApplicationsNetworkingNetworkingModem,
  "note-add": _elements.DocumentsNoteAdd,
  notification: _elements.CommunicationsNotification,
  overflow: _elements.NavOverflow,
  pause: _elements.AVPause,
  pdf: _elements.DocumentsPdf,
  person: _elements.GeneralPerson,
  "phone-mobile-smart": _elements.DevicesPhoneMobileSmart,
  "photo-image": _elements.MediaPhotoImage,
  pinterest: _elements.SocialPinterest,
  "pinterest-box": _elements.SocialPinterestBox,
  placeholder: _elements.GeneralPlaceholder,
  platform: _elements.ProductsPlatform,
  "platform-technology": _elements.TechnologyPlatform,
  play: _elements.AVPlay,
  "play-alt": _elements.AVPlayAlt,
  "plus-circle-outline": _elements.NavPlusCircleOutline,
  power: _elements.TechnologyPower,
  ppt: _elements.DocumentsPpt,
  preferences: _elements.NavPreferences,
  processor: _elements.ProductsProcessor,
  profile: _elements.NavProfile,
  qq: _elements.SocialQq,
  "qq-box": _elements.SocialQqBox,
  qzone: _elements.SocialQzone,
  "qzone-box": _elements.SocialQzoneBox,
  receipt: _elements.ShoppingReceipt,
  refresh: _elements.NavRefresh,
  "remove-minus": _elements.NavRemoveMinus,
  renren: _elements.SocialRenren,
  "renren-box": _elements.SocialRenrenBox,
  rewind: _elements.AVRewind,
  robotics: _elements.ApplicationsRobotics,
  router: _elements.ApplicationsNetworkingRouter,
  rss: _elements.CommunicationsRss,
  search: _elements.NavSearch,
  select: _elements.NavSelect,
  services: _elements.GeneralServices,
  "settings-gear": _elements.NavSettingsGear,
  share: _elements.NavShare,
  shield: _elements.Shield,
  "shopping-cart": _elements.ShoppingShoppingCart,
  "shopping-cart-add": _elements.ShoppingShoppingCartAdd,
  "shopping-cart-remove": _elements.ShoppingShoppingCartRemove,
  sitemap: _elements.NavSitemap,
  "skip-next": _elements.AVSkipNext,
  "skip-previous": _elements.AVSkipPrevious,
  "sms-message": _elements.CommunicationsSmsMessage,
  soc: _elements.ProductsSoc,
  software: _elements.ProductsSoftware,
  solutions: _elements.ApplicationsSolutions,
  star: _elements.ShoppingStar,
  "star-empty": _elements.ShoppingStarEmpty,
  "star-half": _elements.ShoppingStarHalf,
  stop: _elements.AVStop,
  tablet: _elements.DevicesTablet,
  telematics: _elements.ApplicationsAutomotiveTelematics,
  "touch-app": _elements.TechnologyTouchApp,
  trash: _elements.NavTrash,
  "triangle-down": _elements.NavTriangleDown,
  "triangle-left": _elements.NavTriangleLeft,
  "triangle-right": _elements.NavTriangleRight,
  "triangle-up": _elements.NavTriangleUp,
  tumblr: _elements.SocialTumblr,
  "tumblr-box": _elements.SocialTumblrBox,
  tv: _elements.DevicesTv,
  twitter: _elements.SocialTwitter,
  "twitter-box": _elements.SocialTwitterBox,
  txt: _elements.DocumentsTxt,
  upload: _elements.NavUpload,
  "verified-user": _elements.SecurityVerifiedUser,
  video: _elements.MediaVideo,
  "voice-sound": _elements.ApplicationsVoiceSound,
  "volume-down": _elements.AVVolumeDown,
  "volume-mute": _elements.AVVolumeMute,
  "volume-off": _elements.AVVolumeOff,
  "volume-up": _elements.AVVolumeUp,
  warning: _elements.AlertWarning,
  watch: _elements.DevicesWatch,
  webinar: _elements.MediaWebinar,
  wechat: _elements.SocialWechat,
  "wechat-box": _elements.SocialWechatBox,
  weibo: _elements.SocialWeibo,
  "weibo-box": _elements.SocialWeiboBox,
  wifi: _elements.TechnologyWifi,
  windows: _elements.OsWindows,
  xls: _elements.DocumentsXls,
  youtube: _elements.SocialYoutube,
  "youtube-box": _elements.SocialYoutubeBox,
  zip: _elements.DocumentsZip,
  "zoom-in": _elements.NavZoomIn,
  "zoom-out": _elements.NavZoomOut
};
exports["default"] = _default;